import React from "react";
import AggreementUnitAccess  from "./aggreementUnitAccess";
import { withBottombar } from "../../HOCs";
class AggreeUnitDetailsParent extends React.Component {
  render() {
    return <AggreementUnitAccess {...this?.props} />;
  }
}

const props = {
  top_bar: "title_bar",
}

export default withBottombar(AggreeUnitDetailsParent, props);
